var map = {
	"./MANAVRACHNA.jpeg": 16717,
	"./NIRWAN.png": 91813,
	"./aligarh_muslim_university.png": 66495,
	"./ambedkar_university_delhi.jpeg": 77862,
	"./arunachal_uni.png": 81360,
	"./assam_university.png": 59530,
	"./avi_ins_women.jpeg": 35769,
	"./babasaheb_bhimrao_ambedkar_university.png": 76253,
	"./banaras_hindu_university.png": 71888,
	"./base.png": 61829,
	"./bmlmu.png": 2407,
	"./bubhopal.png": 49801,
	"./career_uni.jpeg": 71004,
	"./central_sanskrit_uni.png": 16218,
	"./central_university_of_andhra_pradesh.png": 76395,
	"./central_university_of_gujarat.png": 20907,
	"./central_university_of_haryana.png": 72187,
	"./central_university_of_himachal_pradesh.png": 49016,
	"./central_university_of_jammu.png": 90217,
	"./central_university_of_jharkhand.png": 81802,
	"./central_university_of_karnataka.png": 42471,
	"./central_university_of_kashmir.png": 63384,
	"./central_university_of_kerala.png": 87525,
	"./central_university_of_odisha.png": 34343,
	"./central_university_of_rajasthan.png": 65077,
	"./central_university_of_south_bihar.png": 76817,
	"./central_university_of_tamil_nadu.png": 38845,
	"./csmu-logo.jpg": 55908,
	"./ctuap.png": 36849,
	"./cvv.png": 59659,
	"./dayalbagh_ins.png": 29454,
	"./devi_ahilya.png": 3435,
	"./dr_apj_tech_uni.png": 41860,
	"./dr_hari_singh_gaur_v.png": 57932,
	"./galgotias.png": 46079,
	"./gujarat_vidyapith.png": 13843,
	"./guru_ghasidas_vishwavidyalaya.png": 49051,
	"./gurukul_kangri.png": 48988,
	"./hemvati_nandan_bahuguna_garhwal_university.png": 73641,
	"./ies_uni.png": 8098,
	"./igntu.png": 82155,
	"./iimt.png": 82355,
	"./jamia_millia_islamia.png": 5754,
	"./jamiahamdard.png": 21829,
	"./jawaharlal_nehru_university.png": 78475,
	"./jharkhand_raksha_uni.png": 57029,
	"./juit.jpeg": 15435,
	"./kr_manglam.png": 50503,
	"./laxmibai_pe.png": 73591,
	"./mahatma_gandhi_antarrashtriya_hindi_vishwavidyalaya.png": 29811,
	"./mahatma_gandhi_central_university.png": 52306,
	"./manipur_university.png": 30955,
	"./maulana_azad_national_urdu_university.png": 40617,
	"./mewar_uni.png": 92435,
	"./mizoram_university.png": 37622,
	"./mjpru.png": 42260,
	"./mmmut.png": 57060,
	"./nagaland_university.png": 58395,
	"./national_sanskrit_university.png": 67065,
	"./niit_univ.png": 72303,
	"./north_eastern_hill_university.png": 21805,
	"./policeuni.jpeg": 82469,
	"./pondicherry_university.png": 29614,
	"./rajiv_gandhi_university.png": 26773,
	"./rnbglobal.jpeg": 35204,
	"./ruraluniv.png": 79232,
	"./shri_lal_bahadur_shastri_national_sanskrit_university.png": 60909,
	"./sikkim_university.png": 69199,
	"./sud-logo.png": 77358,
	"./tezpur_university.png": 28637,
	"./the_english_and_foreign_languages_university.png": 36808,
	"./tiss.png": 99129,
	"./tmu.png": 19114,
	"./tripura_university.png": 8642,
	"./university_of_allahabad.png": 72229,
	"./university_of_delhi.png": 49431,
	"./university_of_hyderabad.png": 74629,
	"./vaishno_devi_uni.png": 20932,
	"./vikram_uni.png": 70087,
	"./visva_bharati_university.png": 20470
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 98092;